import {ContactInfo} from "Components/Contacts/Contact.styles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMailForward, faMobileAlt} from "@fortawesome/free-solid-svg-icons";
import {SVPAutocomplete} from "Components/Dropdowns/SVPAutocomplete";
import React from "react";
import PropTypes from "prop-types";

export const ContactsAutoComplete = ({users, contact, setContact, isDisabled = false}) => {
    const contactsOptions = isDisabled ? [contact] : users;

    function getLabel(contactOption) {
        if (!contactOption) {
            return "";
        }

        let lbl = contactOption.full_name;
        if (!contactOption.is_active) {
            lbl = lbl + " (Disabled)";
        }

        return lbl;
    }

    return <SVPAutocomplete
        options={contactsOptions?.map((contactOption) => ({
            label: getLabel(contactOption),
            id: contactOption?.id,
            is_active: contactOption?.is_active,
        }))}
        onChange={(e, newValue) => {
            if (!setContact) {
                return;
            }

            if (newValue) {
                const selectedUser = users.find((u) => u.id === +newValue.id);
                setContact(selectedUser);
            } else {
                setContact(contact);
            }
        }}
        isDisabled={isDisabled || !setContact}
        isDisableInactiveOptions={true}
        value={contact?.full_name}
        footerText={
            <ContactInfo>
                <span className="small">
                    <FontAwesomeIcon icon={faMailForward} />
                    &nbsp;
                    {contact?.email}
                </span>
                {contact?.mobile_phone &&
                    <span className="small">
                        <FontAwesomeIcon icon={faMobileAlt} />
                        &nbsp;
                        {contact?.mobile_phone}
                    </span>
                }
            </ContactInfo>
        }
    />;
};

ContactsAutoComplete.propTypes = {
    users: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        full_name: PropTypes.string,
        email: PropTypes.string,
        mobile_phone: PropTypes.string,
    })),
    setContact: PropTypes.func,
    contact: PropTypes.shape({
        id: PropTypes.number,
        full_name: PropTypes.string,
        email: PropTypes.string,
        mobile_phone: PropTypes.string,
    }),
    isDisabled: PropTypes.bool,
};
